import config from "@/config"
import http from "@/utils/request"

export default {
    list: {
		url: `${config.API_URL}/eventType/`,
		name: "查询事件类型",
		get: async function(data){
			return await http.get(this.url, data);
		}
	}
}
